import React, { Component } from 'react';
import '../assets/css/reset.css'
import '../assets/css/App.css'
import Header from './Header';
import Footer from './Footer';
import SpinnerLoad from './SpinnerLoad';
import { useNavigate } from 'react-router-dom'

class SessionExpired extends Component {

  constructor(props) {
    super(props);
    this.state = {
      spinner: true
    }
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  onButtonClick() {
    this.props.navigate("/customer-portal")
  }

  render() {
    return (
      <div className="App">
        <Header />
        {this.state.spinner ?
        <div className="main-content">
          <div className="ccpa-wrapper">
            <div className="component-section">
              <div className="max-width-20 position-center margin-center">
                <p className="timeout">Your session has been expired!</p>
                <p className="margin-top-2 margin-bottom-2"> Please click on the below button to login.</p>
                <a href="#" onClick={this.onButtonClick}>Request New Access Code</a>
              </div>
            </div>
          </div>
        </div> : <SpinnerLoad/>}
         <Footer/>
      </div>
    );
  }
}

function SessionExpiredWrapper(props) {
  const navigate = useNavigate();
  return <SessionExpired {...props} navigate={navigate} />;
}

export default SessionExpiredWrapper;
